import { EditNotifications } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import '../../assets/css/AboutUs.css';
import video_aboutus from '../../assets/videos/intro_video.mp4';
import image_aboutus from '../../assets/images/aboutus_bs_video.png';
import pause_button from '../../assets/images/pause_button_aboutus.png';
import first_icon from '../../assets/images/first_icon.png';
import second_icon from '../../assets/images/second_icon.png';
import third_icon from '../../assets/images/third_icon.png';
import fourth_icon from '../../assets/images/third_icon.png';
import OurQuality from '../../Components/Home/OurQuality';
import { StaticPages } from '../../Redux/services/Apis';
import axios from 'axios';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';

const AboutUs = () => {
    // let navigate = useNavigate();
    // const vidRef = useRef(null);
    // const handlePlayVideo = () => {
    //     vidRef.current.play();
    // }
    const [state, setState] = useState(null);
    const [state2, setState2] = useState(null);


    useEffect(() => {
        showLoader('flex');
        axios.get(StaticPages, {
            headers: {
                "Application-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            }
        }).then((res) => {
            setState(res.data.response.data.data[0].content);
            setState2(res.data.response.data.data[3].content);
            showLoader('none');

        })
            .catch(error => {
                console.log('error from checkredux page', error)
                showLoader('none');
                toast("Network Error");
            })

    }, [])

    useEffect(() => {
        window.scroll(0, 0);
    }, [])


    return (
        <div className='about_us'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"ABOUT ME"} />
            </section>
            <section className='about_us_content'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 mb-5'>
                            <div dangerouslySetInnerHTML={{ __html: state }} className='f-mon-light f-18 mb-0 mt-5'>
                            </div>
                            <Link to="/tips" className='btn btn-light bt-pink-aboutus mt-3'>
                                GET BETTING TIPS
                            </Link>
                        </div>

                    </div>
                </div>
            </section>
            <div className='ourQuality pt-cus-aboutus pos-rel overflow-hide-x'>
                <div className='bg-packages-shahke'>

                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 text-center' >
                            <p className='text-white f-mon-reg f-30 mb-0 txt-captl mt-rezzz'>Why Choose Me?</p>
                            <p className='text-white f-mon-bold f-50 lh-01'>WHAT MAKES US <span className='clr-e0'>“Big Dog”</span></p>
                            <div className='border-btm-pink-secondsec'></div>
                            <p className='text-white f-mon-light mt-3 wdth-80-per'>Well apart from my extensive experience of over 3 decades, here are the following reasons:</p>
                        </div>
                        <div className='col-lg-12'>
                            <div className='icons_second_sec'>
                                <div className='text-center'>
                                    {/* <img src={first_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt'>Experience</p>
                                </div>
                                <div className='text-center'>
                                    {/* <img src={second_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt'>Inside Information</p>
                                </div>
                                <div className='text-center'>
                                    {/* <img src={third_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt' >Commitment</p>
                                </div>
                                <div className='text-center'>
                                    {/* <img src={fourth_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt'>Transparency</p>
                                </div>
                                <div className='text-center'>
                                    {/* <img src={fourth_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt'>Guarantees</p>
                                </div>
                                <div className='text-center'>
                                    {/* <img src={fourth_icon} alt="icon second sec" /> */}
                                    <p className='text-white mt-3 bet-txt'>Profit</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className="row">
                        <div className="col-lg-12 text-center mt-cus-about-us">
                            <p className='mt-cus-about-us'></p>
                            <p className="f-30 f-mon-reg text-white mb-0 txt-captl">
                                Still not sure
                            </p>
                            <p className="f-50 f-mon-bold text-white lh-01 mt-1">
                                WHY JOIN ME?
                            </p>
                            <div className="border-btm-pink-secondsec my-3">
                            </div>

                            <div dangerouslySetInnerHTML={{ __html: state2 }} className='wdth-80-per text-white f-mon-light f-20 mt-3'>
                            </div>
                            <Link to="/packages" className="btn btn-light f-16 f-mon-reg btn-pink-now mb-5 mt-4 pad-btn-ho-fifth">
                                JOIN NOW
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AboutUs;